<template>
  <section :class="['section', 'child-view', 'section--expertise', 'section--expertise-child', 'section--expertise-ux']">
    <div class="wrapper" :class="{ 'with-modal': isModalVisible}">
      <div class="content">
        <div class="heading">
          <div class="back-btn">
            <router-link
              :to="`/expertise`">
            </router-link>
            <span>back</span>
          </div>
        </div>
        <div class="expertise-holder">
          <ul class="parts-number">
            <li class="number-1">
              <span class="number">/1</span>
              <span class="text">UX Design</span>
              <ul class="list-tools">
                <li>
                  <img src="../assets/images/programs_icons/figma.svg" alt="figma">
                </li>
                <li>
                  <img src="../assets/images/programs_icons/adobexd.svg" alt="adobe xd">
                </li>
                <li>
                  <img src="../assets/images/programs_icons/sketch.svg" alt="sketch">
                </li>
                <li>
                  <img src="../assets/images/programs_icons/miro.svg" alt="miro">
                </li>
              </ul>
            </li>
          </ul>
          <div class="expertise-container">
            <span class="circle-title">UX</span>
            <div class="circle-holder">
              <ul class="circle-block">
                <li class="circle-button size-0">
                  <div class="text-holder"
                    @click="openModal('sketch')">
                    <span class="text">Sketch</span>
                  </div>
                </li>
                <li class="circle-button size-1">
                  <div class="text-holder"
                    @click="openModal('user-story')">
                    <span class="text">User <br />Story</span>
                  </div>
                </li>
                <li class="circle-button size-0">
                  <div class="text-holder"
                    @click="openModal('surveys')">
                    <span class="text">Surveys</span>
                  </div>
                </li>
                <li class="circle-button size-1">
                  <div class="text-holder"
                    @click="openModal('lean-canvas')">
                    <span class="text">Lean  <br />Canvas</span>
                  </div>
                </li>
                <li class="circle-button size-0">
                  <div class="text-holder"
                    @click="openModal('cjm')">
                    <span class="text">CJM</span>
                  </div>
                </li>
                <li class="circle-button size-1">
                  <div class="text-holder"
                    @click="openModal('user-research')">
                    <span class="text">User <br />Research</span>
                  </div>
                </li>
                <li class="circle-button size-0">
                  <div class="text-holder"
                    @click="openModal('jtbd')">
                    <span class="text">JTBD</span>
                  </div>
                </li>
              </ul>
              <ul class="circle-area">
                <li class="circle-button size-3">
                  <div class="text-holder"
                    @click="openModal('competitor-analysis')">
                    <span class="text">Competitor <br />Analysis</span>
                  </div>
                </li>
                <li class="circle-button">
                </li>
                <li class="circle-button size-2">
                  <div class="text-holder"
                    @click="openModal('prototypes')">
                    <span class="text">Prototypes</span>
                  </div>
                </li>
                <li class="circle-button size-2">
                  <div class="text-holder"
                    @click="openModal('wireframes')">
                    <span class="text">Wireframes</span>
                  </div>
                </li>
                <li class="circle-button">
                </li>
                <li class="circle-button size-3">
                  <div class="text-holder"
                    @click="openModal('information-architecture')">
                    <span class="text">Information <br />Architecture</span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div><!--end content-->
    </div>
    <window-modal v-show="isModalVisible" v-model="modalData[activeItem]" @close="closeModal"></window-modal>
  </section>
</template>

<script>
import Footer from '@/components/UI/Footer';
import { mapActions } from 'vuex';
import WindowModal from '@/components/modals/WindowModal.vue';

export default {
  mounted() {
    document.addEventListener('keydown', this.onKeydown);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.onKeydown);
  },
  data() {
    return {
      isModalVisible: false,
      activeItem: 'sketch',
      modalData: {
        sketch: {
          title: 'Sketching',
          content: 'Sketching in UX design is the process of quickly drawing rough, hand-drawn sketches or wireframes to explore and communicate design ideas and concepts. It serves as a valuable tool for brainstorming, visualizing layouts, and iterating on design solutions, helping designers and teams to rapidly prototype and refine their user experiences.',
          linkUrl: 'https://www.figma.com/proto/Vi0Ug4vuU1O7xmT5H2zAKh/UX-Methods-MD-Team-Library?node-id=4653-7307&viewport=-9614%2C-10%2C0.14&t=gHZFkB93xJuKAIr2-1&scaling=scale-down-width&content-scaling=fixed&starting-point-node-id=4653%3A7307&page-id=0%3A1',
          sizeClass: 'size-1',
          positionClass: 'down-position',
        },
        'user-story': {
          title: 'User Story',
          content: 'A “User Story” in UX design is a concise, informal narrative that describes a specific user\'s goal or need within the context of a product or service. It typically follows a template like "As a [user type], I want [a goal] so that [benefit or reason]," helping designers and development teams understand and prioritize user requirements and design features accordingly.',
          linkUrl: 'https://www.figma.com/proto/Vi0Ug4vuU1O7xmT5H2zAKh/UX-Methods-MD-Team-Library?node-id=4653-5990&viewport=-9614%2C-10%2C0.14&t=gHZFkB93xJuKAIr2-1&scaling=scale-down-width&content-scaling=fixed&starting-point-node-id=4653%3A5990&page-id=0%3A1',
          sizeClass: 'size-1',
        },
        surveys: {
          title: 'Surveys',
          content: 'Surveys in UX design are data collection tools that involve presenting a set of structured questions to a group of users or participants to gather quantitative data about their opinions, preferences, and experiences with a product or service. Surveys help designers to obtain a broader understanding of user demographics, needs, and satisfaction, providing valuable insights that inform design decisions and refine the user experience.',
          linkUrl: 'https://www.figma.com/proto/Vi0Ug4vuU1O7xmT5H2zAKh/UX-Methods-MD-Team-Library?node-id=4653-4638&viewport=-9614%2C-10%2C0.14&t=gHZFkB93xJuKAIr2-1&scaling=scale-down-width&content-scaling=fixed&starting-point-node-id=4653%3A4638&page-id=0%3A1',
        },
        'lean-canvas': {
          title: 'Lean Canvas',
          content: 'A “Lean Canvas” is a strategic tool used in UX design and product development to outline a concise one-page business plan for a new product or project. It helps designers and teams define key elements such as customer segments, problems, solutions, channels, and revenue streams, fostering a clear understanding of the product\'s value proposition and its alignment with user needs and market dynamics.',
          linkUrl: 'https://www.figma.com/proto/Vi0Ug4vuU1O7xmT5H2zAKh/UX-Methods-MD-Team-Library?node-id=4653-5982&viewport=-9614%2C-10%2C0.14&t=gHZFkB93xJuKAIr2-1&scaling=scale-down-width&content-scaling=fixed&starting-point-node-id=4653%3A5982&page-id=0%3A1',
          sizeClass: 'size-1',
        },
        cjm: {
          title: 'CJM',
          content: 'CJM, or “Customer Journey Mapping”, is a strategic tool in UX design used to visualize and analyze the end-to-end experience of a customer as they interact with a product or service. It helps UX designers understand user touchpoints, emotions, and pain points throughout their journey, enabling them to make informed design decisions that improve the overall user experience.',
          linkUrl: 'https://www.figma.com/proto/Vi0Ug4vuU1O7xmT5H2zAKh/UX-Methods-MD-Team-Library?node-id=4653-5983&viewport=-9614%2C-10%2C0.14&t=gHZFkB93xJuKAIr2-1&scaling=scale-down-width&content-scaling=fixed&starting-point-node-id=4653%3A5983&page-id=0%3A1',
        },
        'user-research': {
          title: 'User Research',
          content: 'User research in UX design involves the systematic process of gathering and analyzing information about the needs, preferences, and behaviors of a product\'s target users. It is a critical component of UX design, providing valuable insights that inform design decisions, improve usability, and ensure that the final product aligns with user expectations and goals.',
          linkUrl: 'https://mobidev.biz',
          sizeClass: 'size-1',
        },
        jtbd: {
          title: 'JTBD',
          content: '“Jobs to be Done” (JTBD) is a framework in UX design that focuses on understanding the underlying motivations and goals of users when they "hire" a product or service to get a job done in their lives. It emphasizes the importance of identifying and addressing the functional, emotional, and social aspects of user needs, enabling designers to create solutions that better align with user intentions and provide a more effective user experience.',
          linkUrl: 'https://mobidev.biz',
          positionClass: 'down-position',
        },
        wireframes: {
          title: 'Wireframing',
          content: 'Wireframing in UX design involves creating simplified, visual representations of a digital interface\'s layout and structure, typically using basic shapes and placeholders for content. It serves as a blueprint for the user interface, allowing designers to plan and communicate the placement of elements, navigation, and overall information hierarchy, helping to ensure a well-organized and user-friendly design.',
          linkUrl: 'https://www.figma.com/proto/Vi0Ug4vuU1O7xmT5H2zAKh/UX-Methods-MD-Team-Library?node-id=4653-7308&viewport=-9614%2C-10%2C0.14&t=gHZFkB93xJuKAIr2-1&scaling=scale-down-width&content-scaling=fixed&starting-point-node-id=4653%3A7308&page-id=0%3A1',
          sizeClass: 'size-3',
          positionClass: 'down-position',
        },
        'information-architecture': {
          title: 'Information Architecture',
          content: 'Information Architecture (IA) in UX design involves the organization and structuring of information within a digital product or website to enhance usability and findability. It includes creating intuitive navigation systems, categorizing content, and defining the relationships between different pieces of information to ensure that users can easily access and understand the content they seek, ultimately improving the overall user experience.',
          linkUrl: 'https://mobidev.biz',
          sizeClass: 'size-3',
        },
        'competitor-analysis': {
          title: 'Competitor Analysis',
          content: '“Competitor Analysis” in UX design involves the systematic evaluation and comparison of a product or service with its direct competitors in the market. It aims to identify strengths, weaknesses, opportunities, and threats, providing valuable insights that inform design decisions, help differentiate the product, and ultimately enhance the user experience to gain a competitive edge.',
          linkUrl: 'https://www.figma.com/proto/Vi0Ug4vuU1O7xmT5H2zAKh/UX-Methods-MD-Team-Library?page-id=0%3A1&node-id=4645-4586&viewport=-9614%2C-10%2C0.14&t=xyRb9BQzUbNmD5NY-1&scaling=scale-down-width&content-scaling=fixed&starting-point-node-id=427%3A3540',
          sizeClass: 'size-3',
        },
        prototypes: {
          title: 'Prototypes',
          content: 'Prototypes in UX design are interactive representations of a product or interface that allow designers to visualize and test design concepts before the final product is developed. They help UX designers gather feedback, iterate on design ideas, and identify potential issues, ultimately leading to more user-centered and effective design solutions.',
          linkUrl: 'https://www.figma.com/proto/Vi0Ug4vuU1O7xmT5H2zAKh/UX-Methods-MD-Team-Library?node-id=4653-7310&viewport=-9614%2C-10%2C0.14&t=gHZFkB93xJuKAIr2-1&scaling=scale-down-width&content-scaling=fixed&starting-point-node-id=4653%3A7310&page-id=0%3A1',
          sizeClass: 'size-2',
          positionClass: 'down-position',
        },
      },
    };
  },
  methods: {
    ...mapActions({ fetchExpertisePageContent: '/expertise/expertise:fetch' }),
    openModal(activeItemName) {
      this.activeItem = activeItemName;
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    onKeydown(event) {
      if (event.key === 'Escape') {
        this.closeModal();
      }
    },
  },
  components: {
    Footer,
    WindowModal,
  },
};
</script>



// WEBPACK FOOTER //
// src/views/ExpertiseUx.vue